var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"pdfdoc",staticClass:"pdf-document"},_vm._l((_vm.pages),function(page){return _c('PDFPage',{key:_vm.currentPage,attrs:{"page":page,"scale":_vm.scale,"fileID":_vm.file.id},on:{"rendered":_vm.pageRendered,"error":_vm.onError}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }